import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { useCampaignMutation } from "./useCampaignMutation";
import RetailNotification from "components/Notification";

export const useRedirectUrlUpdate = (form: any, data: any) => {
  const { t } = useTranslation();

  const { changeValue } = useCampaignMutation("redirect", data?.id);

  const queryClient = useQueryClient();

  const [redirectUrlStates, setRedirectUrlStates] = useState({
    visible: false,
    url: "",
  });

  const handleRedirectUrlChange = ({
    target,
  }: React.ChangeEvent<HTMLTextAreaElement>) => {
    setRedirectUrlStates({
      visible: true,
      url: target.value,
    });
  };

  const { mutateAsync, isLoading: isRedirectUrlUpdating } = useMutation(
    changeValue
  );

  const openRedirectUrl = () => {
    setRedirectUrlStates({
      visible: true,
      url: data?.redirect?.custom_url,
    });
    form.setFieldsValue({
      url: data?.redirect?.custom_url,
    });
  };

  const onRedirectUrlCancel = () =>
    setRedirectUrlStates({
      visible: false,
      url: "",
    });

  const onRedirectUrlOk = async () => {
    const { url } = form.getFieldsValue();
    try {
      await mutateAsync({
        custom_url: url,
        product_list: null,
        type: "CUSTOM",
      });
      queryClient.invalidateQueries("single_campaign", data?.id);
      queryClient.invalidateQueries(["table", { type: "CREATIVES" }]);
      RetailNotification.showNotification(
        "success",
        "",
        t("pages.acc.campaignDetails.redirectUrlUpdated")
      );
    } catch (e) {
      RetailNotification.showNotification(
        "error",
        "",
        t("components.campaignForm.firstStep.errorStates.generalErr")
      );
    } finally {
      setRedirectUrlStates({
        visible: false,
        url: "",
      });
    }
  };

  return {
    redirectUrlStates,
    openRedirectUrl,
    onRedirectUrlCancel,
    onRedirectUrlOk,
    isRedirectUrlUpdating,
    handleRedirectUrlChange,
  };
};
